import { useMutation } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';

import { supabaseClient } from 'src/auth/supabase';
import { routes } from 'src/constants/routes';

import { useCheckIsRebooker } from './use-check-is-rebooker';

export const usePasswordLoginSupabase = () => {
    const location = useLocation();
    const { mutate } = useCheckIsRebooker();

    return useMutation<unknown, Error, { email: string; password: string }>({
        mutationKey: ['auth', 'password', 'login'],
        mutationFn: async ({ email, password }) => {
            const res = await supabaseClient.auth.signInWithPassword({
                email,
                password,
            });

            if (res.error) throw res.error;

            return res.data;
        },
        onSuccess: () => {
            if (!location.pathname.includes(routes.yourDetails.index)) return;
            mutate();
        },
    });
};
